'use client';

import React from 'react';
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip,  } from 'recharts';
import { BandScore } from '@/data/mockAssessment';

interface BandRadarChartProps {
  scores: BandScore[];
}

const TARGET_BAND = 7.0;

const CustomTooltip = ({ active, payload }: { active?: boolean; payload?: { name: string; value: number }[] }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border rounded-lg p-3 shadow-md text-xs">
        {payload.map((entry, i) => (
          <div key={`tt-${i + 1}`} className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: entry.name === 'Your Score' ? 'var(--primary)' : 'var(--muted-foreground)' }} />
            <span className="text-muted-foreground">{entry.name}:</span>
            <span className="font-bold text-foreground">{entry.value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default function BandRadarChart({ scores }: BandRadarChartProps) {
  const data = scores.map((s) => ({
    criterion: s.code,
    'Your Score': s.score,
    'Band 7 Target': TARGET_BAND,
  }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <RadarChart data={data} margin={{ top: 10, right: 30, bottom: 10, left: 30 }}>
        <PolarGrid stroke="var(--border)" />
        <PolarAngleAxis
          dataKey="criterion"
          tick={{ fontSize: 12, fontWeight: 600, fill: 'var(--foreground)' }}
        />
        <PolarRadiusAxis
          angle={30}
          domain={[0, 9]}
          tickCount={4}
          tick={{ fontSize: 10, fill: 'var(--muted-foreground)' }}
          stroke="var(--border)"
        />
        <Radar
          name="Band 7 Target"
          dataKey="Band 7 Target"
          stroke="var(--muted-foreground)"
          fill="var(--muted)"
          fillOpacity={0.3}
          strokeDasharray="4 4"
          strokeWidth={1.5}
        />
        <Radar
          name="Your Score"
          dataKey="Your Score"
          stroke="var(--primary)"
          fill="var(--primary)"
          fillOpacity={0.15}
          strokeWidth={2}
        />
        <Tooltip content={<CustomTooltip />} />
      </RadarChart>
    </ResponsiveContainer>
  );
}